import { render, staticRenderFns } from "./dakaModel.vue?vue&type=template&id=7e0c27e6&scoped=true&"
import script from "./dakaModel.vue?vue&type=script&lang=js&"
export * from "./dakaModel.vue?vue&type=script&lang=js&"
import style0 from "./dakaModel.vue?vue&type=style&index=0&id=7e0c27e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0c27e6",
  null
  
)

export default component.exports